import { useState } from 'react';
import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { useRouter } from 'next/router';
import EcoButton from 'eco-design/base/eco-button';
import PartnerModal from '../PartnerModal';

import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.HomeownersSection');
    const { locale } = useRouter();
    const [modalVisible, setModalVisible] = useState(false);

    const { pageStatus } = useProductStore();

    const handleButtonClick = () => {
        setModalVisible(true);
    };

    const renderButton = () => {
        return <EcoButton children={t('btn1')} onClick={handleButtonClick} />;
    };

    const dataA: EcoBannerProps = {
        layout: 'center-center',
        title: t('title_4'),
        lChildren: renderButton(),
        lHref: '#subscription-products-section',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Ocean Pro Be the First to Know_You deserve better. Soon, you will get it.',
        },
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
